import { useState } from 'react'
import { useSelector } from 'react-redux'

import { ReactComponent as IconInfo } from '@/assets/images/icons/icon-info.svg'
import logoPsb from '@/assets/images/partners/logo-psb.webp'

import PartnerInfo from '@/components/Modals/PartnerInfo/PartnerInfo'

import { HERO_API } from '@/api'
import { getStoreAbid } from '@/store/slices/app'

import styles from './FormatBuyModal.module.scss'
import Modal from '../Modal/Modal'

const mainPartner = {
  link: 'https://www.psbank.ru/personal/page-zabegrf',
  reklama: {
    name: 'ПАО «Промсвязьбанк»',
    inn: 'ИНН: 7744000912',
    gov_id: 'erid: 2Vtzqwxw8Yj',
  },
}

const getTotalCost = (price, count = 1, insurance = 0) => {
  return +(price * count + insurance * count).toFixed(2)
}

const FormatBuyModal = ({ isOpen, onClose, format }) => {
  const abid = useSelector(getStoreAbid)
  const [insurance, setInsurance] = useState(false) // on/off insurance
  const [checkTown, setCheckTown] = useState(false)
  const [isOpenPartnerInfo, setIsOpenPartnerInfo] = useState(false)

  const handleChangeInput = () => setInsurance(!insurance)

  const handleRedirectChange = (evt) => {
    evt.preventDefault()

    window.location.href = `${HERO_API}/basket-fill-outside/event?public_id=${format.event_public_id}&city_id=${format.city.id}&format_id=${format.public_id}&insurance=${insurance}&abid=${abid}`
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} closeBtnStyles={styles.closeBtn}>
        <div className={styles.container}>
          <div className={styles.descBlock}>
            <h2 className={styles.title}>Подтверждение об ознакомлении</h2>
            <div className={styles.desc}>
              <ul className={styles.requirements}>
                {format.requirements.map((el) => (
                  <li key={el}>{el}</li>
                ))}
              </ul>
            </div>
            <div className={styles.formWrapper}>
              <div className={styles.cityWrap}>
                <p className={styles.cityText}>
                  Город:&nbsp;&nbsp;<span className={styles.city}>{format.address}</span>
                </p>
                <div className={styles.inputWrap}>
                  <input
                    defaultValue={checkTown}
                    onChange={() => setCheckTown(!checkTown)}
                    className={`${styles.checkbox} visually-hidden`}
                    type="checkbox"
                    id="check-town-ref"
                  />
                  <label className={styles.label} htmlFor="check-town-ref">
                    С медицинской справкой ознакомлен и город подтверждаю
                  </label>
                  {format.insurance_available ? (
                    <>
                      <input
                        value={insurance}
                        onChange={handleChangeInput}
                        className={`${styles.checkbox} visually-hidden`}
                        type="checkbox"
                        id="check-insurance"
                      />
                      <label className={styles.label} htmlFor="check-insurance">
                        Страховка строго 18+
                      </label>
                    </>
                  ) : null}
                </div>
              </div>
            </div>

            <div className={styles.logo}>
              <img src={logoPsb} width={112} height={35} alt="Партнёр ПСБ" />

              <button className={styles.btnInfo} onClick={() => setIsOpenPartnerInfo(true)}>
                <span className="visually-hidden">Информация о партнёре</span>
                <IconInfo width={14} height={14} />
              </button>
            </div>
          </div>

          <div className={styles.costBlock}>
            <b className={styles.worth}>Стоимость:</b>
            {format.insurance_available ? (
              <p className={styles.counts}>
                <span>Страховка</span>
                <span className={styles.cost}>{insurance ? format.insurance_cost * 1 : 0} &#8381;</span>
              </p>
            ) : null}
            <p className={styles.counts}>
              <span>Билет</span>
              <span className={styles.cost}>
                {getTotalCost(format.price, 1, insurance && format.insurance_cost)} &#8381;
              </span>
            </p>

            <div className={styles.btnWrap}>
              <button className={styles.btn} type="button" onClick={handleRedirectChange} disabled={!checkTown}>
                Перейти к покупке
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <PartnerInfo partner={mainPartner} isOpen={isOpenPartnerInfo} onClose={() => setIsOpenPartnerInfo(false)} />
    </>
  )
}

export default FormatBuyModal
